import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_86: FaireProductEntity = {
  token: "catalog_prod_prod-86",
  type: "product",
  name: "Gift Box",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 65.05,
  msrpDollars: 162.63,
  sku: "AN0086",
  caseSize: 12,
  material: "Ceramic",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 223,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_wall-decor"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
